import React from 'react';
import { DisclaimerText } from './DisclaimerText';
import { SaleDisclaimer } from './SaleDisclaimer';
import { StepDisclaimer } from './StepDisclaimer/StepDisclaimer';
export const PageDisclaimer = function (_temp) {
  let {
    isMobile
  } = _temp === void 0 ? {} : _temp;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DisclaimerText, null, /*#__PURE__*/React.createElement(SaleDisclaimer, null)), ' ', /*#__PURE__*/React.createElement(DisclaimerText, null, /*#__PURE__*/React.createElement(StepDisclaimer, {
    isMobile: isMobile
  })));
};
//# sourceMappingURL=PageDisclaimer.js.map